module.exports = __webpack_public_path__ + "img/рз_28.b4194957.png";